import { dataFetch } from '@lib/ggj-utils'

export default {
  // 用户绑卡申请,发送短信验证码
  bindCard(params) {
    return dataFetch('/cashier-desk/api/user/bank/bind/apply', params, {
      'method': 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
	// 用户直接绑卡申请
	bindDirect(params) {
		return dataFetch('/cashier-desk/api/user/bank/bind/direct', params, {
			'method': 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	},
  // 用户绑卡确认，绑定银行卡
  bindCardConfirm(params) {
    return dataFetch('/cashier-desk/api/user/bank/bind/confirm', params, {
      'method': 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 根据银行卡id，设置默认卡（收益到账卡)
  setDefault(params) {
    return dataFetch('/cashier-desk/api/user/bank/modify/default', params, {
      'method': 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  //判断是否要进入安全升级页面
  goToSafeUp(params) {
    return dataFetch('/cashier-desk/api/user/bank/bind/intercept', params, {
      'method': 'get'
    })
  },
  // /query/certification/info
  // 根据渠道来源，获取实名信息
  getIdentifyInfo(params) {
    return dataFetch('/cashier-desk/api/user/bank/query/certification/info', params, {
      'method': 'get'
    })
  },
  // 获取用户绑定的银行卡列表
  getBankList(params) {
    return dataFetch('/cashier-desk/api/user/bank/query/list', params, {
      'method': 'get'
    })
  },
  // 获取单个银行卡信息
  getBankInfo(params) {
    return dataFetch('/cashier-desk/api/user/bank/query/detail', params, {
      'method': 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 获取所有支持绑定的银行卡列表
  getAllBankList(params) {
    return dataFetch('/cashier-desk/api/user/bank/query/support/list', params, {
      'method': 'get'
    })
  },
  // 根据银行卡id，解绑银行卡
  unbindBank(params) {
    return dataFetch('/cashier-desk/api/user/bank/unbind', params, {
      'method': 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

}
